module.exports = __webpack_public_path__ + "static/media/project7.8bb642ca.png";